import { IWoundTherapy } from '@dokucoach/common-types';
import * as yup from 'yup';
import { PackageSize, values } from '../../../enums';
import { IOrder, IOrderWithDoctorId } from './IOrder';

export const CreateWoundTherapyOrderSchema = yup.object({
  doctorId: yup.string().required(),
  woundTherapyId: yup.string().required(),
  residentId: yup.string().required(),
  note: yup.string().nullable(),
  order: yup.string().required(),
  packageSize: yup
    .mixed<PackageSize>()
    .oneOf([...values(PackageSize)])
    .nullable(),
});

export interface IWoundTherapyOrder extends IOrder {
  packageSize?: PackageSize;
  woundTherapy: IWoundTherapy;
}

export interface IWoundTherapyOrderWithDoctorId extends IOrderWithDoctorId {
  packageSize?: PackageSize;
  woundTherapy: IWoundTherapy;
}

export interface ICreateWoundTherapyOrder
  extends Omit<
    IWoundTherapyOrder,
    'id' | 'doctor' | 'woundTherapy' | 'orderedAt' | 'deliveredAt' | 'discriminator'
  > {
  doctorId: string;
  woundTherapyId: string;
  residentId: string;
}

export interface ICreateWoundTherapyOrders {
  orders: ICreateWoundTherapyOrder[];
}

export const CreateWoundTherapyOrdersSchema = yup.object({
  orders: yup.array(CreateWoundTherapyOrderSchema).default([]),
});
